import React, { useState } from 'react';
import { NavLink, Outlet, Link } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { Home, LogOut, Menu, X, Users, Utensils } from 'lucide-react';

const DoctorShell = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-sans_bone">
      <aside className={`fixed top-0 bottom-0 left-0 w-60 bg-white border-r border-sans_line z-30 transform ${open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'} transition-transform`}>
        <div className="p-6 border-b border-sans_line">
          <Link to="/" className="font-serif text-xl text-sans_ink">Saans Ayurved</Link>
          <div className="text-[10px] uppercase tracking-[0.22em] text-sans_mute mt-1">Doctor</div>
        </div>
        <nav className="p-3 space-y-1">
          <NavLink to="/doctor" end className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-[13px] transition-colors ${isActive ? 'bg-sans_ink text-sans_bone' : 'text-sans_ink hover:bg-sans_bone'}`}>
            <Home className="w-4 h-4" strokeWidth={1.5} /> Appointments
          </NavLink>
          <NavLink to="/doctor/diet-plans" data-testid="doctor-nav-diet" className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-[13px] transition-colors ${isActive ? 'bg-sans_ink text-sans_bone' : 'text-sans_ink hover:bg-sans_bone'}`}>
            <Utensils className="w-4 h-4" strokeWidth={1.5} /> Diet Planning
          </NavLink>
        </nav>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-sans_line bg-white">
          <div className="text-xs text-sans_mute mb-1">{user?.name}</div>
          <div className="text-xs text-sans_mute mb-2">{user?.email}</div>
          <button onClick={async () => { await logout(); window.location.href = '/'; }} className="flex items-center gap-2 text-xs text-sans_ink hover:opacity-70">
            <LogOut className="w-3.5 h-3.5" strokeWidth={1.5} /> Sign out
          </button>
        </div>
      </aside>

      <div className="lg:hidden h-14 bg-white border-b border-sans_line flex items-center justify-between px-4 sticky top-0 z-20">
        <button onClick={() => setOpen((s) => !s)} className="text-sans_ink" aria-label="Menu">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
        <div className="font-serif text-lg text-sans_ink">Doctor</div>
        <div className="w-5" />
      </div>

      <main className="lg:pl-60">
        <div className="p-6 md:p-12 max-w-6xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DoctorShell;
